'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@/utilities/ui';
import useClickableCard from '@/utilities/useClickableCard';
import Link from 'next/link';
import React, { Fragment } from 'react';
import { Media } from '@/components/Media';
export const Card = props => {
  const $ = _c(36);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    card,
    link
  } = useClickableCard(t0);
  const {
    className,
    doc,
    relationTo,
    showCategories,
    title: titleFromProps
  } = props;
  let t1;
  if ($[1] !== doc) {
    t1 = doc || {};
    $[1] = doc;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    slug,
    categories,
    meta,
    title
  } = t1;
  let t2;
  if ($[3] !== meta) {
    t2 = meta || {};
    $[3] = meta;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    description,
    image: metaImage
  } = t2;
  const hasCategories = categories && Array.isArray(categories) && categories.length > 0;
  const titleToUse = titleFromProps || title;
  let t3;
  if ($[5] !== description) {
    t3 = description?.replace(/\s/g, " ");
    $[5] = description;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const sanitizedDescription = t3;
  const href = `/${relationTo}/${slug}`;
  let t4;
  if ($[7] !== className) {
    t4 = cn("border border-border rounded-sm overflow-hidden bg-card hover:cursor-pointer", className);
    $[7] = className;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== metaImage) {
    t5 = !metaImage && <div className="">No image</div>;
    $[9] = metaImage;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== metaImage) {
    t6 = metaImage && typeof metaImage !== "string" && <Media resource={metaImage} size="360px" />;
    $[11] = metaImage;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <div className="relative w-full ">{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== href || $[17] !== link || $[18] !== titleToUse) {
    t8 = titleToUse && <div className="prose"><h3><Link className="not-prose" href={href} ref={link.ref}>{titleToUse}</Link></h3></div>;
    $[16] = href;
    $[17] = link;
    $[18] = titleToUse;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== description || $[21] !== sanitizedDescription) {
    t9 = description && <div className="mt-2">{description && <p>{sanitizedDescription}</p>}</div>;
    $[20] = description;
    $[21] = sanitizedDescription;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== categories || $[24] !== hasCategories || $[25] !== showCategories) {
    t10 = showCategories && hasCategories && <div className="uppercase text-sm mt-4 bg-accent text-primary inline-block p-2 rounded-sm">{showCategories && hasCategories && <div>{categories?.map((category, index) => {
          if (typeof category === "object") {
            const {
              title: titleFromCategory
            } = category;
            const categoryTitle = titleFromCategory || "Untitled category";
            const isLast = index === categories.length - 1;
            return <Fragment key={index}>{categoryTitle}{!isLast && <Fragment>,  </Fragment>}</Fragment>;
          }
          return null;
        })}</div>}</div>;
    $[23] = categories;
    $[24] = hasCategories;
    $[25] = showCategories;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t8 || $[29] !== t9) {
    t11 = <div className="p-4">{t8}{t9}{t10}</div>;
    $[27] = t10;
    $[28] = t8;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== card.ref || $[32] !== t11 || $[33] !== t4 || $[34] !== t7) {
    t12 = <article className={t4} ref={card.ref}>{t7}{t11}</article>;
    $[31] = card.ref;
    $[32] = t11;
    $[33] = t4;
    $[34] = t7;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
};